module.exports = __webpack_public_path__ + "static/media/uaeu-logo-white.8c69bc30.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/uaeu-logo-white.png
// module id = 15
// module chunks = 0